<template>
  <cargo-advance-select
    :disabled="disabled"
    :select-type="TYPE_NAMES.static_data_Department"
    :cache="false"
    filterable
    :default-value="departmentId||''"
    :static-options="options"
    :placeholder="placeholder"
    filter-type="global"
    @parentCallBack="p=>{$emit('change',p)}"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { SyncManager } from '@/utils/commonUtil'
import { User } from '@/class/model/sys/User'

export default {
  name: 'CargoDepartmentNewSelect',
  components: { cargoAdvanceSelect },
  props: {
    disabled: { type: Boolean, default: false },
    salesId: { type: Number, default: 0 },
    officeId: { type: Number, default: 0 },
    departmentId: { type: Number, default: 0 },
    enables: { type: Boolean, default: false },
    showOfficePrefix: { type: Boolean, default: true },
    placeholder: { type: String, default: '' }
  },
  data() {
    return {
      TYPE_NAMES,
      originOptions: [],
      extraOption: null
    }
  },
  computed: {
    options() {
      let data = this.originOptions
      if (this.extraOption) {
        const index = this.originOptions.findIndex(p => p.uuid === this.extraOption.uuid)
        if (index < 0) {
          data = [this.extraOption, ...this.originOptions]
        }
      }
      if (this.enables) {
        return data.filter(p => p.active || p.departmentId === this.departmentId)
      }
      return data
    }
  },
  watch: {
    async salesId(newVal, oldVal) {
      this.syncManager.execute(async() => {
        this.branchOfficeCheck = Number(cache.config.get('departmentSalesOfficeCheck')) === 1
        if (this.branchOfficeCheck && this.salesId > 0) {
          await Promise.all([this.getSalesOfficeSet()])
          this.refreshOptions()
        }
      })
    },
    officeId(newVal, oldVal) {
      if (this.officeList && this.allDepartments) {
        this.syncManager.execute(() => {
          this.refreshOptions()
        })
      }
    },
    departmentId(newVal) {
      if (newVal && this.allDepartments) {
        this.syncManager.execute(() => {
          this.handleDefaultValue()
        })
      }
    }
  },
  async created() {
    this.TYPE_NAMES = TYPE_NAMES
    this.branchOfficeCheck = false
    this.officeList = null
    this.officeUuidToId = new Map()
    this.officeIdSet = new Set() // 销售分公司ID集合
    this.allDepartments = null
    this.syncManager = new SyncManager()
    this.syncManager.execute(async() => {
      await cache.load(cacheName.CONFIG)
      this.branchOfficeCheck = Number(cache.config.get('departmentSalesOfficeCheck')) === 1
      this.init()
      const ajaxResults = []
      if (this.branchOfficeCheck && this.salesId > 0) {
        ajaxResults.push(this.getSalesOfficeSet())
      }
      await Promise.all(ajaxResults)
      this.refreshOptions()
    })
  },
  methods: {
    init() {
      if (!this.officeList) {
        this.officeList = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        /* 分公司uuid到officeId的映射 */
        for (const item of this.officeList) {
          this.officeUuidToId.set(item.uuid, Number(item.officeId))
        }
      }
      if (!this.allDepartments) {
        this.allDepartments = getCacheListByKey(basicCacheKeys.basic_data_Department_All)
      }
    },
    async getSalesOfficeSet() {
      let userList = getCacheListByKey(basicCacheKeys.basic_data_User)
      userList = userList.filter(p => p.userId === this.salesId)
      this.officeIdSet.clear()
      if (userList.length > 0 && userList[0].defaultOfficeId > 0) {
        this.officeIdSet.add(userList[0].defaultOfficeId)
      } else {
        const officeList = await User.getUserDepartmentOffices('role', 'sales', this.salesId)
        for (const item of officeList) {
          this.officeIdSet.add(item.officeId)
        }
      }
    },
    refreshOptions() {
      this.originOptions = []
      if (this.officeId > 0) {
        for (const item of this.allDepartments) {
          const officeId = this.officeUuidToId.get(item.officeUuid)
          if (this.branchOfficeCheck && !this.officeIdSet.has(officeId)) {
            continue
          }
          if (!this.branchOfficeCheck && officeId !== this.officeId) {
            continue
          }
          this.originOptions.push({ ...item })
        }
      }
      if (this.branchOfficeCheck && this.showOfficePrefix) {
        for (const s of this.originOptions) {
          this.appendPrefix(s)
        }
      }
      this.handleDefaultValue()
    },
    handleDefaultValue() {
      this.extraOption = null
      if (!this.departmentId) {
        return
      }
      for (const item of this.originOptions) {
        if (item.departmentId === this.departmentId) {
          return
        }
      }
      let department = this.allDepartments.find(p => p.departmentId === this.departmentId)
      if (department) {
        department = { ...department }
        if (this.branchOfficeCheck && this.showOfficePrefix) {
          this.appendPrefix(department)
        }
      }
      this.extraOption = department || null
    },
    appendPrefix(item) {
      let t = ''
      if (item.officeUuid) {
        const office = this.officeList.find(p => p.uuid === item.officeUuid)
        if (office) {
          t = office.code
        }
      }
      // 已经增加过officeCode的，不再操作了
      if (Object.prototype.hasOwnProperty.call(item, 'prefix')) {
        if (item.prefix) {
          return
        }
      }
      item.prefix = true
      item.chineseName = t + '-' + item.chineseName
      item.englishName = t + '-' + item.englishName
    }
  }
}
</script>

<style>
</style>
